var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M1.82 4.044 7 9.399 12.198 4l.962.875-5.364 5.565a1.164 1.164 0 0 1-1.636 0L.875 4.945z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export default ForwardRef;